import { largeIcon } from '.';

export const allTemplates = (c: TemplateCopyItem): Template => {
  return {
    article: {
      onboardingPopup: {
        loggedIn: `
          ${largeIcon}
          <p class="pre-title">${c.preTitle}</p>
          <h2 class="title">${c.title}</h2>
          <p class="secondary">${c.secondary}</p>
          <button class="button-primary" data-action-close aria-label="sluiten">${c.buttonClose}</button>`,
        loggedOut: `
          <p class="pre-title">${c.preTitle}</p>
          <h2 class="title">${c.title}</h2>
          <p class="secondary">${c.secondary}</p>
          <div class='button-group'>
            <button class="button-primary" data-action-login>${c.buttonLogin}</>
            <button class="button-secondary" data-action-close aria-label="sluiten">${c.buttonClose}</button>
          </div>`,
      },
    },
    listPage: {
      emptyList: `
      <section class="list-no-bookmarks is-logged-in">
        ${largeIcon}
        <h2 class="title">${c.title}</h2>
        <p class="secondary">${c.secondary}</p>
      </section>
      `,
      loggedOutCopy: `
        <section class="list-no-bookmarks">
          ${largeIcon}
          <p class="pre-title">${c.preTitle}</p>
          <h2 class="title">${c.title}</h2>
          <button class="button-primary" data-action-login>${c.buttonLogin}</button>
        <section class="list-no-bookmarks">`,
    },
  };
};
